
import formularmodal from '~/mixins/formularmodal';
export default {
  mixins: [formularmodal],
  props: [],
  data() {
    return {
      modal: {
        event: 'display::modal',
        titel: null,
        modelname: 'Model',
        model: 'models'
      }
    }
  },
  computed: {},
  watch: {},
  methods: {

  },

}
